// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeBaseAddTemplate_heading__hQaEs","buttonLink":"LandscapeBaseAddTemplate_buttonLink__qkIcv","marginTop":"LandscapeBaseAddTemplate_marginTop__TfQPg"};